import { useEffect, useState } from "react";
import { Orders } from "@/interface/entityInterface";
import axiosInstance from "@/utils/axiosInstance";
import Calendar from "@/components/calendar/calendar";
import { CalendarEvent } from "@/components/calendar/calendar-types";
import { addMonths } from "date-fns";

const TravelReservations = () => {
  const [orders, setOrders] = useState<Orders[]>([]);
  const [events, setEvents] = useState<CalendarEvent[]>([]);
  const [mode, setMode] = useState<"month" | "week" | "day">("month");
  const [date, setDate] = useState(new Date());
  const [endDate, setEndDate] = useState(addMonths(new Date(), 1));

  useEffect(() => {
    const getOrders = async () => {
      const { data } = await axiosInstance.get<Orders[]>(`/taxi-orders`, {
        params: {
          start: 1,
          end: 10000,
        },
      });
      setOrders(data);
    };

    getOrders();
  }, []);

  useEffect(() => {
    if (orders.length === 0) return;
    const dataEvents: CalendarEvent[] = [];
    orders.map((order) => {
      let color = ""
      if (order.status === "NEW_ORDER") color = "yellow"
      else if (order.status === "ACCEPTED") color = "green"
      else if (order.status === "REJECTED") color = "red"
      else color = "gray"
      dataEvents.push({
        ...order,
        id: "" + order.id,
        title: order.pickup,
        start: new Date(order.pickup_time),
        end: new Date(order.pickup_time),
        color,
      });
    });
    setEvents(dataEvents);
  }, [orders]);

  return (
    <Calendar
      endDate={endDate}
      setEndDate={setEndDate}
      events={events}
      setEvents={setEvents}
      date={date}
      setDate={setDate}
      mode={mode}
      setMode={setMode}
    />
  );
};

export default TravelReservations;
